;(function () {
  'use strict'

  angular.module('contrast.auth').factory('AuthService', AuthService)

  function AuthService(
    $cookies,
    $rootScope,
    $q,
    AuthCookieService,
    AuthFactory,
    pendoService,
    CONTRAST_UI_KEY,
    CONTRAST_CSRF_COOKIE,
    PORTAL_TYPES,
    PORTAL_TYPE,
    AUTH_EVENTS
  ) {
    'ngInject'

    var _initializeTsv = true,
      _authenticated = false

    return {
      getInitializeTsv: getSetInitializeTsv,
      setInitializeTsv: getSetInitializeTsv,
      clearCookies: clearCookies,
      isAuthenticated: isAuthenticated,
      setAuthenticated: setAuthenticated,
      isUserActive: isUserActive,
      isAdminPortal: isAdminPortal
    }

    function getSetInitializeTsv(initializeTsv) {
      if (arguments.length) {
        _initializeTsv = initializeTsv
      }
      return _initializeTsv
    }

    function clearCookies() {
      $cookies.remove(CONTRAST_UI_KEY, { path: '/Contrast' })
      $cookies.remove(CONTRAST_UI_KEY, { path: '/' })
      $cookies.remove(CONTRAST_CSRF_COOKIE, { path: '/' })
    }

    function isAuthenticated() {
      _authenticated = AuthCookieService.isSessionActive()
      return _authenticated
    }

    function setAuthenticated(authenticated) {
      _authenticated = authenticated
      if (authenticated) {
        $rootScope.$broadcast(AUTH_EVENTS.AUTHENTICATED_TRUE)
      } else {
        clearCookies()
        pendoService.initializeAnonymous()
        $rootScope.$broadcast(AUTH_EVENTS.AUTHENTICATED_FALSE)
      }
    }

    function isUserActive(segmentName) {
      var adminPortal = isAdminPortal()

      segmentName = segmentName || ''

      return AuthFactory.isUserActive(adminPortal).then(
        function () {
          setAuthenticated(true)

          return $q.when({ authenticated: true })
        },
        function (response) {
          var status = response.status

          if (status >= 400 && status <= 499) {
            setAuthenticated(false)
            return $q.reject({ authenticated: false, path: segmentName })
          }

          switch (status) {
            case 301:
              setAuthenticated(true)
              return $q.when({ authenticated: true })

            case 303:
              if (!adminPortal) {
                setAuthenticated(true)
                return $q.when({ authenticated: true, tsv_code: true })
              }
              break

            case 307:
              if (!adminPortal) {
                setAuthenticated(true)
                return $q.when({ authenticated: true, tsv_setup: true })
              }
              break

            default:
              break
          }

          return $q.reject({
            authenticated: true,
            path: segmentName,
            network_error: true
          })
        }
      )
    }

    function isAdminPortal() {
      return PORTAL_TYPE == PORTAL_TYPES.ADMIN
    }
  }
})()
